import { ENTRY_DATA_EXPEDITED_PROGRAM_CONTENTS } from "@frontend/common";
import { EntryDataValueInfo } from "@frontend/common/src/types/entryData/clinicalTrialStatus.types";

import { ArticleEntryData } from "@/types/articleEntryData.types";
import { ExpeditedProgramContentsShellKeysNotAttributionId } from "@/types/expeditedProgram.types";
import { ArticleSectionType } from "@FillInTableContainer/types/fillInTable.types";

import { moveItemToPosition } from "./changeEntryDataOrder";
import { DragInfoType } from "../hooks/useHandleTableCreatorValueDrag";

type Props = {
  data: ArticleEntryData;
  draggedIndexInfo: DragInfoType;
  articleSectionKey: ArticleSectionType;
  shellKey: ExpeditedProgramContentsShellKeysNotAttributionId;
  tableIndex?: number;
};

export const dragChangeExpeditedProgramValueOrder = ({
  data,
  draggedIndexInfo,
  articleSectionKey,
  shellKey,
  tableIndex,
}: Props) => {
  if (articleSectionKey === "Expedited Program")
    return {
      ...data,
      [articleSectionKey]: {
        ...data[articleSectionKey],
        [ENTRY_DATA_EXPEDITED_PROGRAM_CONTENTS]: data[articleSectionKey]?.[
          ENTRY_DATA_EXPEDITED_PROGRAM_CONTENTS
        ]?.map((tableData, currentTableIndex) => {
          if (currentTableIndex === tableIndex) {
            return {
              ...tableData,
              [shellKey]: {
                ...tableData[shellKey],
                value: moveItemToPosition(
                  tableData[shellKey].value as EntryDataValueInfo[],
                  draggedIndexInfo[0] || 0,
                  draggedIndexInfo[1] || 0,
                ),
              },
            };
          }

          return tableData;
        }),
      },
    };

  return {
    ...data,
  };
};
